function populateSiblingProducts() {
  const form = document.querySelector('.product-purchase-form')
  if (!form) {
    return
  }

  const productId = form.dataset.productId
  if (!productId?.length) {
    return
  }

  let currentProductHandle = null
  let styleCode = null
  try {
    const product = JSON.parse(document.getElementById('ProductJson-' + productId).innerHTML)
    currentProductHandle = product?.handle
    styleCode = product?.tags?.find(tag => tag?.startsWith('style:'))?.split(':')?.[1]
    console.log("styleCode", styleCode);
    if (!styleCode?.length) {
      return
    }
  } catch (e) {
    return
  }

  const query = `
    {
      products(first: 250, query:"tag:'style:${styleCode}'") {
        edges {
          node {
            handle
            featuredImage {
              url(transform: { maxWidth: 300 })
            }
            tags
          }
        }
      }
    }
  `

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': '9c445d937bc8968e99e6c343c7de362b',
    },
    body: JSON.stringify({ query }),
  }

  fetch('https://portier-australia-pty-ltd.myshopify.com/api/2023-07/graphql', options)
    .then((response) => response.json())
    .then((data) => {
      const products = data?.data?.products?.edges?.map(edge => ({
        handle: edge?.node?.handle,
        image: edge?.node?.featuredImage?.url,
        color: edge?.node?.tags?.find(tag => tag?.startsWith('colour:'))?.split(':')?.[1],
      }))?.sort((a, b) => {
        if (a?.handle === currentProductHandle && b?.handle !== currentProductHandle) return -1
        if (b?.handle === currentProductHandle && a?.handle !== currentProductHandle) return 1
        return 0
      })

      console.log('products', products);

      if (!products?.length) {
        return
      }

      const siblingPickerDiv = document.querySelector('.sibling-picker')
      if (!siblingPickerDiv) {
        return
      }

      const colorDiv = document.createElement('div')
      colorDiv.className = 'sibling-color-wrapper'
      colorDiv.innerHTML = `<span class="sibling-color-title">Colour</span>: ${products?.[0]?.color}`

      const gridDiv = document.createElement('div')
      gridDiv.className = 'sibling-grid'

      products?.forEach(p => {
        const siblingDiv = document.createElement('a')
        siblingDiv.className = 'sibling'
        siblingDiv.href = `/products/${p?.handle}`

        const imageDiv = document.createElement('img')
        imageDiv.src = p?.image
        siblingDiv.appendChild(imageDiv)

        gridDiv.appendChild(siblingDiv)
      })

      siblingPickerDiv.appendChild(colorDiv)
      siblingPickerDiv.appendChild(gridDiv)
    })
    .catch((error) => {});
}

(function ($) {
  populateSiblingProducts()
})(theme.jQuery);
